import UpdateComponent from 'components/table/UpdateComponent';
import { getSizesById, update } from 'controllers/Size';
import React, { useState, useEffect,useCallback } from 'react'
import {  useParams ,useHistory} from 'react-router-dom';

function UpdateSizes() {
  const [inputText, setInputText] = useState('');

  const { id } = useParams()
  const history = useHistory();


  const handleChange = (event) => {
      setInputText(event.target.value);
    };
  
const handleClick = () => {
  update({ id:id,value: inputText, label: inputText },history)
  };
  
 const dataStream =   useCallback( async () => {
  const typeofgarment = await getSizesById(id);
    setInputText(typeofgarment.value)
}, [id]); 
  
  
  useEffect(() => {
    dataStream()
},[dataStream])

    return (
    <>
      <div style={{display:'flex',justifyContent:'center',marginTop:'2%'}}>
          <UpdateComponent
            lebel="Size"
            inputText={inputText}
            handleChange={handleChange}
            handleClick={handleClick}
          />
            
      </div>
    </>
  )
}

export default UpdateSizes;